import React, { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import UserManagementData from "./UserManagementData";
import DesignationManagementData from "./DesignationManagement/DesignationManagementData";

const UserManagement = ({organizationList}) => {
  const [openModule, setOpenModule] = useState("userManagement");
 
  return (
    <>
      <div className="h-100 d-flex flex-column w-100">
        <div className="bg-white border-bottom px-4 py-3">
          <div className="hstack justify-content-between">
            <h6 className="fw-semibold m-0">Management List</h6>
            <div className="hstack gap-2">
              <Button
                variant={
                  openModule === "userManagement" ? "primary" : "outline-primary"
                }
                size="sm"
                onClick={() => setOpenModule("userManagement")}
              >
                Users
              </Button>
              <Button
                variant={
                  openModule === "designationManagement" ? "primary" : "outline-primary"
                }
                size="sm"
                onClick={() => setOpenModule("designationManagement")}
              >
                Designation
              </Button>
              <Button
                variant={
                  openModule === "accessManagement" ? "primary" : "outline-primary"
                }
                size="sm"
                onClick={() => setOpenModule("accessManagement")}
              >
                Access
              </Button>
            </div>
          </div>
        </div>
        <div className="flex-grow-1 overflow-auto bg-light">
          {openModule === "userManagement" && <UserManagementData organizationList={organizationList} />}
          {openModule === "designationManagement" && <DesignationManagementData />}
        </div>
      </div>
    </>
  );
};

export default UserManagement;
